var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1De(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12) scale(1.25) translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7.5,
    width: 12,
    height: 9,
    rx: 0.75,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 6,
    width: 1.5,
    height: 2.25,
    rx: 0.375,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 6,
    width: 1.5,
    height: 2.25,
    rx: 0.375,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 1.5,
    height: 2.25,
    rx: 0.375,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 6,
    width: 1.5,
    height: 2.25,
    rx: 0.375,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 9.75,
    x2: 8.25,
    y2: 13.5,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 9.75,
    x2: 10.5,
    y2: 12,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.75,
    y1: 9.75,
    x2: 12.75,
    y2: 15,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9.75,
    x2: 15,
    y2: 12.75,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1De);
export default __webpack_public_path__ + "static/media/1DE.89dbe52d32371ec75c29fff98957a5c8.svg";
export { ForwardRef as ReactComponent };